import './polyfills'

import { loadConfig } from 'settings'

const bootstrapApp = async () => {
  await loadConfig()

  const { renderApp } = await import('./ReactApp')
  renderApp()
}

bootstrapApp()
